/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'

import './UrlInput.css';

import TextInputWithMargin from './TextInputWithMargin';
import Text from 'components/common/Text';


class UrlInput extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      suffixWidth: 170,
      hasFocus: false,
    };
  }

  componentDidMount() {
    const suffixRef = this.suffixRef;
    const suffixWidth = suffixRef.getBoundingClientRect().width
    this.setState({ suffixWidth });
  }

  render() {
    const showSuffix = this.state.hasFocus || !!this.props.value;
    return (
      <div className="cmp-urlinput" style={this.props.style}>
        <TextInputWithMargin
          value={this.props.value}
          name={this.props.name}
          type="text"
          onChange={(e) => { this.props.onChange(e.target.value); }}
          onFocus={() => { this.setState({ hasFocus: true })}}
          onBlur={() => { this.setState({ hasFocus: false })}}
          label={this.props.label}
          hint={<Text colorName="med-dark-gray">{this.props.hint}</Text>}
          style={{ paddingRight: this.state.suffixWidth }}
          hasFixedLabel={this.props.hasFixedLabel}
        />

        <div className="cmp-urlinput-suffix" style={{ visibility: showSuffix ? null : 'hidden' }}>
          <span className="cmp-urlinput-hidetext" style={{ maxWidth: `calc(100% - ${this.state.suffixWidth}px)` }}>
            {this.props.value}
          </span>
          <div ref={(r) => { this.suffixRef = r; }}>
            {this.props.urlSuffix}
          </div>
        </div>

      </div>
    );
  }
}

export default UrlInput;
